import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination"

import SwiperCore, {
  Pagination
} from 'swiper';

SwiperCore.use([Pagination]);

export const SliderContainer = (
  {
    sliderclass = 'default',
    contentclass = 'default',
    currentSlide = null,
    initial = 0,
    children
  }
) => {

  const handleChangeSlider = (e: any) => {
    currentSlide(e.realIndex);
  }

  return (
    <>
      <Swiper
        slidesPerView={'auto'}
        pagination={{
          clickable: true
        }}
        touchStartForcePreventDefault={false}
        className={"swipper-container " + contentclass}
        onSlideChange={handleChangeSlider}
        initialSlide={initial}
      >
        {
          children.map((child, ind) => {
            return (
              <SwiperSlide key={'slidechild' + (ind + 1)} className={sliderclass}>
                {child}
              </SwiperSlide>
            );
          })
        }

      </Swiper>
    </>
  )
}
